export default "__VITE_ASSET__CNnd65Lj__"